import React, { useEffect, useRef, useState } from "react";
import { MdOutlinePhoneInTalk } from "react-icons/md";
import LazyLoader from "./LazyLoader";
import { Link } from 'react-router-dom';

const PersonalizedSection = () => {
    const [isFirstSectionVisible, setIsFirstSectionVisible] = useState(false);
    const [isSecondSectionVisible, setIsSecondSectionVisible] = useState(false);
    const [isMounted, setIsMounted] = useState(false);
    const [isInViewFirst, setIsInViewFirst] = useState(false);
    const [isInViewSecond, setIsInViewSecond] = useState(false);

    const firstSectionRef = useRef(null);
    const secondSectionRef = useRef(null);
    const firstElementRef = useRef(null);
    const secondElementRef = useRef(null);

    useEffect(() => {
        setIsMounted(true);
    }, []);

    useEffect(() => {
        const firstObserver = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        setIsFirstSectionVisible(true);
                    }
                });
            },
            {
                threshold: 0.5,
            }
        );

        const secondObserver = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        setIsSecondSectionVisible(true);
                    }
                });
            },
            {
                threshold: 0.5,
            }
        );

        if (firstSectionRef.current) {
            firstObserver.observe(firstSectionRef.current);
        }
        if (secondSectionRef.current) {
            secondObserver.observe(secondSectionRef.current);
        }

        return () => {
            if (firstSectionRef.current) {
                firstObserver.unobserve(firstSectionRef.current);
            }
            if (secondSectionRef.current) {
                secondObserver.unobserve(secondSectionRef.current);
            }
        };
    }, []);

    useEffect(() => {
        const observerFirst = new IntersectionObserver(
            (entries) => {
                const entry = entries[0];
                if (entry.isIntersecting) {
                    setIsInViewFirst(true);
                }
            },
            {
                threshold: 0.5,
            }
        );

        const observerSecond = new IntersectionObserver(
            (entries) => {
                const entry = entries[0];
                if (entry.isIntersecting) {
                    setIsInViewSecond(true);
                }
            },
            {
                threshold: 0.5,
            }
        );

        if (firstElementRef.current) {
            observerFirst.observe(firstElementRef.current);
        }
        if (secondElementRef.current) {
            observerSecond.observe(secondElementRef.current);
        }

        return () => {
            if (firstElementRef.current) {
                observerFirst.unobserve(firstElementRef.current);
            }
            if (secondElementRef.current) {
                observerSecond.unobserve(secondElementRef.current);
            }
        };
    }, []);

    return (
        <>
            <div className="pt-80 xl-screen-padding">
                <div
                    ref={firstSectionRef}
                    className={`custom-padding custom-width custom-padding-top flex flex-col md:flex-row items-center md:items-center md:justify-between space-y-6 md:space-y-0 bg-white ${isFirstSectionVisible ? "animate-slide-up" : ""}`}
                >
                    <div className={`w-full md:w-4/12 custom-width relative ${isFirstSectionVisible ? "animate-slide-up" : ""}`}>
                        <div className="relative col-tablet rounded-lg flex items-center justify-center">
                            <LazyLoader
                                src={require("../../src/assets/images/large_circle.png")}
                                alt="Salad Bowl"
                                placeholder="#f0f0f0"
                                className="object-cover rounded-full"
                            />

                            <div className="absolute small_circle top-[-90px] left-[-40px] p-2 rounded-full shadow-sm hover-effect">
                                <LazyLoader
                                    src={require("../../src/assets/images/small_circle1.png")}
                                    alt="Scanning Food Data"
                                    placeholder="#f0f0f0"
                                    className="object-cover w-52 h-52"
                                />
                            </div>

                            <div className="absolute small_circle bottom-[-10px] right-0 p-2 rounded-full shadow-sm hover-effect2">
                                <LazyLoader
                                    src={require("../../src/assets/images/small_circle2.png")}
                                    alt="Fruits on Scale"
                                    placeholder="#f0f0f0"
                                    className="object-cover w-32 h-32"
                                />
                            </div>
                        </div>
                    </div>

                    <div className={`w-full md:w-8/12 space-left-extra content-container-tab md:pl-6 pt-4 md:pt-0 ${isFirstSectionVisible ? "animate-slide-up" : ""}`}>
                        <h2 className="custom-padding-bottom text-[#2b343b] text-h2 font-bold ">
                            <h2
                                ref={firstElementRef}
                                className={`custom-padding-bottom text-[#2b343b] text-h2 font-semibold text-gray-800 client-text ${isInViewFirst ? 'typewriter-effect' : ''}`}
                            >
                                <span>Your Personalized Path to Wellness</span>
                            </h2>
                        </h2>
                        <p className="custom-padding-bottom text-p font-lato text-[#000000] ">
                            Welcome to Nutrillion—where your health journey becomes personal. At the
                            heart of every journey toward a healthier life is a story—<span className="text-[#7c517e] font-bold">YOUR STORY</span>.
                        </p>
                        <p className="custom-padding-bottom text-p font-lato text-[#000000]">
                            It's a story about who you are, how you live, and the choices you make. But
                            most importantly, it's about the future you're creating, one where your
                            body feels strong, vibrant, and active.
                        </p>
                        <p className="custom-padding-bottom text-p font-lato text-[#000000]">
                            At Nutrillion, we believe that true wellness is not a one-size-fits-all
                            approach. That’s why we’re here—to help you write the next chapter of your
                            health journey with personalized nutrition that speaks directly to you.
                        </p>
                        <button className="common-btn-all text-white rounded">
                            <Link to="/about-us" style={{ textDecoration: 'none', color: 'white' }}>
                                Read More
                            </Link>
                        </button>
                    </div>
                </div>
            </div>
            <div className="relative">
                <img
                    src={require("../../src/assets/images/spoon_image1.png")}
                    alt="Small Image"
                    className="spoon-image animate-updown"
                />
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320">
                    {/* <path id="leftWave" fill="#987f3c" d="M0,120L42,120.3C44,118,170,153,270,170.7C384,199,480,224,576,213.3C672,203,768,149,864,149.3C960,150,1056,192,1152,213.3C1248,235,1344,213,1392,192L1440,170.7L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"></path> */}

                    <path id="rightWave" fill="#f2f0ed" d="M0,120L42,120.3C44,118,170,153,270,170.7C384,199,480,224,576,213.3C672,203,768,149,864,149.3C960,150,1056,192,1152,213.3C1248,235,1344,213,1392,192L1440,170.7L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"></path>
                </svg>

                <div >
                    <div className="">
                        <div className="xl-screen-padding w-full bg-[#f2f0ed]">
                            <div className="flex custom-padding bg-[#f2f0ed]">
                                <iframe
                                    width="100%"
                                    height="315"
                                    src="https://www.youtube.com/embed/krIgKr3IC7s"
                                    title="YouTube video"
                                    frameBorder="0"
                                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                    allowFullScreen
                                    style={{ borderRadius: "15px" }}
                                ></iframe>
                            </div>
                            <div
                                ref={secondSectionRef}
                                className={`custom-padding pb-80 pt-80 custom-padding-top container-tab flex flex-col md:flex-row md:items-start md:justify-between space-y-6 md:space-y-0 ${isSecondSectionVisible ? "animate-slide-up" : ""}`}
                            >
                                <div className={`${isSecondSectionVisible ? "animate-slide-up" : ""}`}>
                                    <h2
                                        ref={secondElementRef}
                                        className={`custom-padding-bottom text-[#2b343b] text-h2 font-semibold text-gray-800 client-text ${isInViewSecond ? 'typewriter-effect' : ''}`}
                                    >
                                        <span>Your Story Starts Here</span>
                                    </h2>
                                    <p className="custom-padding-bottom font-lato text-[#000000] text-p">
                                        We understand that change can feel challenging, but we also know that when you have the right support and direction, every step feels easier
                                    </p>
                                    <p className="custom-padding-bottom font-lato text-[#000000] text-p">
                                        <span className="text-[#7c517e] font-bold">
                                            Your health is personal
                                        </span>{" "}
                                        — so why should your nutrition be any different?
                                    </p>
                                    <p className="custom-padding-bottom font-lato text-[#000000] text-p" style={{ paddingBottom: '40px' }}>
                                        Take the first step toward a healthier, more vibrant you. Because
                                        this isn’t just about food—it’s about creating a future where you
                                        feel like the best version of yourself. And that’s a story worth
                                        telling!!
                                    </p>
                                    <div className="relative">
                                        <div className="absolute top-0 left-0 w-[95%] border-t border-gray-300"></div>

                                        <div className="flex flex-col md:flex-row md:space-y-0 md:space-x-4 justify-center py-2">
                                            <div className="flex flex-col md:flex-row md:space-y-0 md:space-x-2 items-center h-full justify-center text-center md:text-left">
                                                <img
                                                    src={require("../../src/assets/images/Vector.png")}
                                                    alt="Happy Customers"
                                                    className="w-12 h-auto"
                                                />
                                                <div>
                                                    <p className="text-[#2B343B] font-prata text-3xl font-semibold cursor-default">
                                                        3000+
                                                    </p>
                                                    <p className="text-[#2B343B] font-lato text-p font-semibold md:font-normal">
                                                        Personal Consultation
                                                    </p>
                                                </div>
                                            </div>

                                            <div className="md:border-r md:border-gray-300 pl-6 per-horizontal-line"></div>

                                            <div className="flex flex-col md:flex-row md:space-y-0 md:space-x-4 items-center px-4 flex-grow h-full per-custom">
                                                <img
                                                    src={require("../../src/assets/images/Vector-1.png")}
                                                    alt="Awards & Features"
                                                    className="w-12 h-auto"
                                                />
                                                <div>
                                                    <p className="text-[#2B343B] font-prata text-3xl font-semibold cursor-default">
                                                        10+
                                                    </p>
                                                    <p className="text-[#2B343B] font-lato text-p font-semibold md:font-normal">
                                                        Countries
                                                    </p>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="absolute bottom-0 left-0 w-[95%] border-t border-gray-300"></div>
                                    </div>
                                    <div className="flex items-center space-x-4 mt-8">
                                        <div className="relative group inline-flex items-center">
                                            <a href="tel:+91-9557439399" className="bg-[#bf9b30] p-3 rounded-full text-white">
                                                <MdOutlinePhoneInTalk className="w-5 h-5" />
                                            </a>
                                        </div>
                                        <div>
                                            <p className="text-p text-[#434343] font-medium">We would love to hear from you</p>
                                            <h3 className="text-h1 font-semibold text-[#303030]">
                                                Connect with us today to discover how we can help you achieve your health goals!                                            </h3>
                                        </div>
                                    </div>

                                </div>
                                <div className={`${isSecondSectionVisible ? "animate-slide-up" : ""}`}>
                                    <LazyLoader
                                        src={require("../../src/assets/images/Group 1000005944.png")}
                                        alt="Balanced Health Illustration"
                                        placeholder="#f0f0f0"
                                        className="rounded-lg space-left-extra-top"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>

    );
};

export default PersonalizedSection;

